/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useMinisitesList } from '@api/hooks';

import SearchableEntitySelect from '../SearchableEntitySelect';

const MinisiteSelect = React.forwardRef(({ placeholder = 'Type to search minisite', children, ...props }, ref) => (
  <SearchableEntitySelect ref={ref} placeholder={placeholder} useList={useMinisitesList} {...props} />
));

export default MinisiteSelect;
